import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";

import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Stack,
  Table,
  Form,
  Breadcrumb,
} from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";

import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";

import solisPowerApi from "../../api/solisPowerApi";
import ".././../assets/css/ListComponentsTable.css";
import { ROUTES } from "../../constants/webRouting";
import {
  formatDate,
  formatDateForView,
  formatDateForViewIST,
  getUserDetails,
} from "../../utils/helper";
import UserSiteVisitModal from "../siteVisit/UserSiteVisitModal";
import InfoPill from "../InfoPill";
import { DateRangePicker } from "rsuite";
import Select from "react-select";
import * as constants from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";

const UserTracking = () => {
  const navigate = useNavigate();
  const userInfo = getUserDetails();
  const [body, setBody] = useState();
  // visit data
  const [visitData, setVisitData] = useState(null);
  const [filterData, setFilterData] = useState({ visit_status: "Pending" });
  const [assignUsers, setAssignUsers] = useState([]);
  const [modalShowUserSiteVisit, setModalShowUserSiteVisit] = useState(false);
  const [dateRange, setDateRange] = React.useState([
    // new Date(),
    // new Date()
  ]);
  const [statusArray, setStatusArray] = useState(constants.SITE_VISIT_STATUS);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState(rows);

  useEffect(() => {
    console.log("visitData", visitData);
  }, [visitData]);
  useEffect(() => {
    const filter = { ...filterData };
    delete filter.owner_name;
    filter.owner_ids = filter?.owner_ids
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    if (Array.isArray(dateRange) && dateRange.length > 0)
      filter.date_range = {
        filed: "createddate",
        createddate: {
          from: formatDate(dateRange?.at(0) || null),
          to: formatDate(dateRange?.at(1) || null),
        },
      };
    fetchUserTrackings(filter);
  }, [dateRange, filterData]);

  async function init() {
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      const resultedUsers = await solisPowerApi.fetchUsers();
      resultedUsers &&
        Array.isArray(resultedUsers) &&
        setAssignUsers(
          resultedUsers.map((user) => ({
            value: user.id,
            label: user.username,
          })),
        );
    }
  }

  async function fetchUserTrackings(filters) {
    const result = await solisPowerApi.fetchUserTrackings(filters);
    console.log("result site visit", result);
    if (result) {
      setBody(result);
      const mappedRows = result.map((item, index) => ({
        id: item.id || index,
        lead_number: item.lead_no || "-",
        lead_no: item.lead_no || "-",
        parentid: item.parentid || null,
        createddate: item.createddate || "-",
        name: item.lead_name || "-",
        lead_name: item.lead_name || "-",
        customer_address: item.customer_address || "-",
        address: item.customer_address || "-",
        city: item.city || "-",
        phone: item.phone || "-",
        project_name: item.project_name || "-",
        accounts: Array.isArray(item.accounts) ? item.accounts : [],
        leadtype: item.leadtype || "-",
        remarks: item.remarks || "-",
        visit_status: item.visit_status || "-",
        owner_ids: Array.isArray(item.owner_ids) ? item.owner_ids : [],
        logindatetime: item.logindatetime || null,
        logoutdatetime: item.logoutdatetime || null,
      }));

      setRows(mappedRows);
      setFilteredRows(mappedRows);
    } else {
      setBody([]);
      setRows([]);
      setFilteredRows([]);
    }
  }

  useEffect(() => {
    init();
  }, []);

  const submitSiteVisit = () => {
    setModalShowUserSiteVisit((prev) => !prev);
    init();
    fetchUserTrackings(filterData);
  };
  const editUser = (visitData) => {
    setVisitData(visitData);
    setModalShowUserSiteVisit((prev) => !prev);
  };
  // Create table headers consisting of 4 columns.
  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const header = [];

  // if (!isMobile) {
  //     header.push(
  //         { title: 'Lead No', prop: 'lead_no', cell: (row) => <Link to={`${ROUTES.LEAD.LIST}/${row.parentid}`} state={{ id: row.parentid }}> {row.lead_no} </Link>, isFilterable: true, isSortable: true, },
  //         //formatDateForView added by shahir hussain 27-08-2025
  //         {
  //             title: "Created Date",
  //             prop: "createddate",
  //             isFilterable: true,
  //             cell: (row) => (
  //                 row?.createddate ? formatDateForView(row.createddate) : ''
  //             ),
  //             isSortable: true,
  //         },
  //         { title: 'Lead Name', prop: 'lead_name', isFilterable: true, isSortable: true, },
  //         {
  //             title: "Address",
  //             prop: "address",
  //         },

  //         {
  //             title: "City",
  //             prop: "city",
  //             isFilterable: true,
  //         },

  //         {
  //             title: "Phone",
  //             prop: "phone",
  //             isFilterable: true,
  //         },

  //         {
  //             title: "Account",
  //             prop: "accounts",
  //             cell: (row) => (

  //                 row.accounts?.map((item) =>
  //                     item?.value && <>
  //                         <Link to={`${ROUTES.ACCOUNT.LIST}/${item.value}`} >
  //                             {item.label}
  //                         </Link>
  //                         <br />
  //                     </>

  //                 )),
  //             isFilterable: true,
  //         },

  //         {
  //             title: "Lead Type",
  //             prop: "leadtype",
  //             isFilterable: true,
  //             isSortable: false,
  //         },
  //         { title: 'Remarks', prop: 'remarks' },
  //         // { title: 'Visit Status', prop: 'visit_status', isFilterable: true },
  //         {
  //             title: "Visit Status",
  //             prop: "visit_status",
  //             isFilterable: true,
  //             isSortable: true,
  //             alignment: { horizontal: "center" },
  //             cell: (row) => (
  //                 <span
  //                     className="badge rounded-pill w-100"
  //                     style={getStatusClass(row.visit_status)}
  //                 >
  //                     {row.visit_status}
  //                 </span>
  //             ),
  //         },
  //         // { title: 'Assign User', prop: 'owner_name', cell: (row) => <Link to={`${ROUTES.USER.LIST}/${row.owner_id}`} state={row}> {row.owner_name} </Link>, isFilterable: true },
  //         {
  //             title: "Assigned Users",
  //             prop: "owner_ids",
  //             cell: (row) => (
  //                 <div className="d-flex flex-wrap gap-1">
  //                     {row.owner_ids?.map((item, index) =>
  //                         item?.value && (
  //                             <Link
  //                                 key={index}
  //                                 to={`${ROUTES.USER.LIST}/${item.value}`}
  //                                 state={row}
  //                                 className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
  //                                 style={{
  //                                     background: "#f5f7fa",
  //                                     border: "1px solid #e0e0e0",
  //                                     transition: "0.2s",
  //                                 }}
  //                                 onMouseEnter={(e) => (e.currentTarget.style.background = "#eaf1ff")}
  //                                 onMouseLeave={(e) => (e.currentTarget.style.background = "#f5f7fa")}
  //                             >
  //                                 {/* <img
  //                             src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
  //                             className="rounded-circle"
  //                             style={{
  //                               height: "30px",
  //                               width: "30px",
  //                               objectFit: "cover",
  //                               border: "2px solid #007bff",
  //                             }}
  //                             alt=""
  //                           /> */}
  //                                 <span className="fw-semibold text-primary">{item.label}</span>
  //                             </Link>
  //                         )
  //                     )}
  //                 </div>
  //             ),

  //             isFilterable: true,
  //         },
  //         {
  //             title: "Actions",
  //             prop: "id",
  //             cell: (row) => {
  //                 if ([PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_SITE_VISIT].some(permission => {
  //                     return userInfo?.permissions?.map(p => p.name).includes(permission);
  //                 })) {
  //                     if (!row.logindatetime) {
  //                         return < Button
  //                             size="sm"
  //                             variant="success"
  //                             onClick={() => { row.action = "check-in"; editUser(row); }}
  //                         >
  //                             Check-In
  //                         </Button >
  //                     } else if (!row.logoutdatetime) {
  //                         return < Button
  //                             size="sm"
  //                             variant="danger"
  //                             onClick={() => { row.action = "check-out"; editUser(row); }}
  //                         >
  //                             Check-Out
  //                         </Button >
  //                     }
  //                 }
  //             }
  //         },

  //     );
  // } else {
  //     //for mobile device
  //     header.push({
  //         title: "Info",
  //         prop: "name",
  //         isFilterable: true,
  //         isSortable: true,
  //         cell: (row) => (
  //             <div className="mobilecard">
  //                 <Link
  //                     to={`${ROUTES.CONTACT.LIST}/${row.id}`}
  //                     state={row}
  //                     style={{ width: "100%" }}
  //                 >
  //                     {row.firstname} {row.lastname}
  //                 </Link>

  //                 <span>
  //                     <i className="fa-solid fa-phone"></i> {row.phone}
  //                 </span>
  //                 <span style={{ width: "80%" }}>
  //                     <i className="fa-solid fa-envelope"></i> {row.email}
  //                 </span>
  //             </div>
  //         ),
  //     });
  // }

  header.push(
    {
      title: "Lead No",
      prop: "lead_no",
      cell: (row) => (
        <Link
          to={`${ROUTES.LEAD.LIST}/${row.parentid}`}
          state={{ id: row.parentid }}
        >
          {" "}
          {row.lead_no}{" "}
        </Link>
      ),
      isFilterable: true,
      isSortable: true,
    },
    //formatDateForView added by shahir hussain 27-08-2025
    {
      title: "Created Date",
      prop: "createddate",
      isFilterable: true,
      cell: (row) =>
        row?.createddate ? formatDateForViewIST(row.createddate) : "",

      isSortable: true,
    },
    {
      title: "Lead Name",
      prop: "lead_name",
      isFilterable: true,
      isSortable: true,
    },
    {
      title: "Project Name",
      prop: "project_name",
      isFilterable: true,
      isSortable: true,
    },
    {
      title: "Address",
      prop: "customer_address",
    },

    {
      title: "City",
      prop: "city",
      isFilterable: true,
    },

    {
      title: "Phone",
      prop: "phone",
      isFilterable: true,
    },

    // {
    //   title: "Account",
    //   prop: "accounts",
    //   cell: (row) =>
    //     row.accounts?.map(
    //       (item) =>
    //         item?.value && (
    //           <>
    //             <Link to={`${ROUTES.ACCOUNT.LIST}/${item.value}`}>
    //               {item.label}
    //             </Link>
    //             <br />
    //           </>
    //         ),
    //     ),
    //   isFilterable: true,
    // },

    // {
    //   title: "Lead Type",
    //   prop: "leadtype",
    //   isFilterable: true,
    //   isSortable: false,
    // },
    { title: "Remarks", prop: "remarks" },
    // { title: 'Visit Status', prop: 'visit_status', isFilterable: true },
    {
      title: "Visit Status",
      prop: "visit_status",
      isFilterable: true,
      isSortable: true,
      alignment: { horizontal: "center" },
      cell: (row) => (
        <span
          className="badge rounded-pill w-100"
          style={getStatusClass(row.visit_status)}
        >
          {row.visit_status}
        </span>
      ),
    },
    // { title: 'Assign User', prop: 'owner_name', cell: (row) => <Link to={`${ROUTES.USER.LIST}/${row.owner_id}`} state={row}> {row.owner_name} </Link>, isFilterable: true },
    {
      title: "Assigned Users",
      prop: "owner_ids",
      cell: (row) => (
        <div className="d-flex flex-wrap gap-1">
          {row.owner_ids?.map(
            (item, index) =>
              item?.value && (
                <Link
                  key={index}
                  to={`${ROUTES.USER.LIST}/${item.value}`}
                  state={row}
                  className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
                  style={{
                    background: "#f5f7fa",
                    border: "1px solid #e0e0e0",
                    transition: "0.2s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#eaf1ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#f5f7fa")
                  }
                >
                  {/* <img
                                src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                                className="rounded-circle"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  objectFit: "cover",
                                  border: "2px solid #007bff",
                                }}
                                alt=""
                              /> */}
                  <span className="fw-semibold text-primary">{item.label}</span>
                </Link>
              ),
          )}
        </div>
      ),

      isFilterable: true,
    },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => {
        if (
          [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_SITE_VISIT].some(
            (permission) => {
              return userInfo?.permissions
                ?.map((p) => p.name)
                .includes(permission);
            },
          )
        ) {
          if (!row.logindatetime) {
            return (
              <Button
                size="sm"
                variant="success"
                onClick={() => {
                  row.action = "check-in";
                  editUser(row);
                }}
              >
                Check-In
              </Button>
            );
          } else if (!row.logoutdatetime) {
            return (
              <Button
                size="sm"
                variant="danger"
                onClick={() => {
                  row.action = "check-out";
                  editUser(row);
                }}
              >
                Check-Out
              </Button>
            );
          }
        }
      },
    },
  );
  const labels = {
    beforeSelect: " ",
  };

  const handleChange = (e) => {
    setFilterData((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };

  const handleClear = () => {
    setFilterData({});
    fetchUserTrackings();
  };

  const getStatusClass = (status) => {
    const statusObj = constants.SITE_VISIT_STATUS.find(
      (value) => value.label === status,
    );
    return statusObj ? statusObj.css : {};
  };

  //   id: item.id || index, // DataGrid ke liye mandatory
  // lead_number: item.lead_no || "-",
  // createddate: item.createddate || "-",
  // name: item.lead_name || "-",
  // address: item.address || "-",
  // city: item.city || "-",
  // phone: item.phone || "-",
  // account: item.account || "-",
  // leadtype: item.leadtype || "-",
  // remarks: item.remarks || "-",
  // visit_status: item.visit_status || "-",
  // owner_ids: Array.isArray(item.owner_ids) ? item.owner_ids : [],
  const columns = [
    // { field: "id", headerName: "ID", width: 70 },
    // { field: "lead_number", headerName: "Lead No", flex: 1 },
    {
      field: "lead_number",
      headerName: "Lead Number",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const row = params.row;

        return (
          <Link
            to={`${ROUTES.LEAD.LIST}/${row.parentid}`}
            state={{ id: row.parentid }}
            style={{
              color: "#1a73e8",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            {row.lead_number}
          </Link>
        );
      },
    },
    {
      field: "createddate",
      headerName: "Created Date",
      flex: 1,
      renderCell: (params) =>
        params.row?.createddate
          ? formatDateForView(params.row.createddate)
          : "",
    },
    { field: "name", headerName: "Lead Name", flex: 1 },
    { field: "customer_address", headerName: "Address", flex: 1 },
    { field: "city", headerName: "City", flex: 1 },
    { field: "phone", headerName: "Phone", flex: 1 },
    // { field: "accounts", headerName: "Accounts", flex: 1 },
    {
      field: "accounts",
      headerName: "Accounts",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const row = params.row;

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {row.accounts?.map(
              (item, index) =>
                item?.value && (
                  <Link
                    key={index}
                    to={`${ROUTES.ACCOUNT.LIST}/${item.value}`}
                    state={row}
                    style={{
                      color: "#1a73e8",
                      textDecoration: "none",
                      fontSize: "13px",
                      lineHeight: "1.4",
                    }}
                  >
                    {item.label}
                  </Link>
                ),
            )}
          </div>
        );
      },
    },
    { field: "leadtype", headerName: "Lead Type", flex: 1 },
    {
      field: "remarks",
      headerName: "Remarks",
      width: 150,
    },
    { field: "visit_status", headerName: "Visit Status", width: 130 },
    {
      field: "owner_ids",
      headerName: "Assign Users",
      flex: 1.5,
      sortable: true,
      renderCell: (params) => {
        const row = params.row;

        return (
          <div className="d-flex flex-wrap gap-1">
            {row.owner_ids?.map(
              (item, index) =>
                item?.value && (
                  <Link
                    key={index}
                    state={row}
                    className="d-inline-flex align-items-center rounded-pill text-decoration-none"
                    style={{
                      padding: "10px 10px", // 👈 height control
                      fontSize: "11px",
                      lineHeight: "1",
                      background: "#f5f7fa",
                      border: "1px solid #e0e0e0",
                      transition: "0.2s",
                      whiteSpace: "nowrap",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#eaf1ff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "#f5f7fa")
                    }
                  >
                    <span className="fw-semibold text-primary" style={{ fontSize: "11px" }}>
                      {item.label}
                      {item.user_type && (
                        <span
                          className="badge rounded-pill bg-light text-dark border ms-1"
                          style={{ fontSize: "10px" }}
                        >
                          {item.user_type}
                        </span>
                      )}
                    </span>
                  </Link>
                ),
            )}
          </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 130,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const row = params.row;

        const hasPermission = [
          PERMISSIONS.MODIFY_ALL,
          PERMISSIONS?.MODIFY_SITE_VISIT,
        ].some((permission) =>
          userInfo?.permissions?.map((p) => p.name).includes(permission),
        );

        if (!hasPermission) return null;

        if (!row.logindatetime) {
          return (
            <Button
              size="sm"
              variant="success"
              onClick={() => {
                editUser({ ...row, action: "check-in" });
              }}
            >
              Check-In
            </Button>
          );
        }

        if (!row.logoutdatetime) {
          return (
            <Button
              size="sm"
              variant="danger"
              onClick={() => {
                editUser({ ...row, action: "check-out" });
              }}
            >
              Check-Out
            </Button>
          );
        }

        return null;
      },
    },
  ];

  // add by alfaiz ansari start here
  const [searchText, setSearchText] = useState("");
  //   const [filteredRows, setFilteredRows] = useState(rows);
  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );

    setFilteredRows(filtered);
  };

  return (
    <Container fluid>
      <DatatableWrapper
        body={body && Array.isArray(body) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50],
          },
        }}
        sortProps={{ initialState: { prop: "createddate", order: "desc" } }}
      >
        <Row className="">
          <Col lg={12} className="">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => navigate(ROUTES.USER_TRACKING)}>
                Site Visit
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col lg={3}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label>Site Status</Form.Label>
              <Form.Select
                name="visit_status"
                value={filterData?.visit_status || ""}
                onChange={handleChange}
              >
                <option value="">--Select-Status--</option>
                {statusArray.map((item, index) => (
                  <option value={item.label} key={index}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicLeadManagerId"
              >
                Assigned User
              </Form.Label>
              <Select
                // isClearable
                className="z-3"
                isMulti
                name="owner_ids"
                onChange={(e) => {
                  handleChange({
                    target: { name: "owner_ids", value: e },
                  });
                }}
                value={filterData?.owner_ids?.filter((item) => item.value)}
                options={assignUsers}
              />
            </Form.Group>
          </Col>
          {/* <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicUsers">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicState"
                            >
                                Users
                            </Form.Label>

                            <Select
                                isMulti
                                placeholder="Select your Users"
                                isClearable
                                options={assignUsers}
                                onChange={(e) => {
                                    handleChange({
                                        target: { name: "owner_ids", value: e },
                                    });
                                }}
                                value={
                                    filterData?.owner_ids?.filter((item) => (item.value))
                                }
                            ></Select>
                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col> */}
        </Row>
        <Row className="align-items-end">
          <Col>
            {/* <Filter
              classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }}
            /> */}
            <div className="leads-header">
              <div className="leads-actions">
                <TextField
                  size="small"
                  placeholder="Search Site Visit..."
                  className="custom-search-field"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
          </Col>
          <Col md={1}>
            <PaginationOptions labels={labels} />
          </Col>
          <Col>
            <DateRangePicker
              value={dateRange}
              onChange={(e) => {
                setDateRange(e);
              }}
              // format="dd/mm/yyyy"
              character=" – "
            />
          </Col>
          <Col className="py-1">
            {/* <BrowserView> */}
            <div className="d-flex py-1 px-2 ">
              <InfoPill
                left="Total"
                right={body?.length}
                rightClasses="bg-custom text-white border-white fw-bold"
                leftClasses="bg-white  fw-bold "
              />
            </div>
            {/* </BrowserView> */}
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            <Stack direction="horizontal" gap={2}>
              {/* <Button
                                size="sm"
                                className="btn-create"
                                onClick={() => createContact(true)}
                            >
                                New Site Visit
                            </Button> */}
              {/* <Button variant="success" onClick={handleSearch}><i class="fas fa-search"></i></Button> */}
              <Button variant="secondary" onClick={handleClear}>
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </Button>
              <Button
                size="sm"
                variant="success"
                onClick={() => navigate(`/quotations/e`)}
                className="create-quotation-btn"
                style={{ marginLeft: "8px" }}
              >
                <i className="fa fa-file-text me-1"></i> Create Quotation
              </Button>
            </Stack>
          </Col>
        </Row>

        {/* <Table striped className="shadow rounded sm my-4" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {
                        (body && Array.isArray(body)) ?
                            <TableBody />
                            :
                            <tbody className="">
                                <tr>
                                    <td colSpan={100} align="center">
                                        <div>
                                            <Spinner />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                    }
                </Table> */}
        {/* <div className="table-scroll my-3">
          <Table striped className="shadow rounded sm my-4">
            <TableHeader
              classes={{ th: "bg-custom text-white sticky-header" }}
            />
            {body && Array.isArray(body) ? (
              <TableBody />
            ) : (
              <tbody className="">
                <tr>
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
        <Pagination
          classes={{
            buttonGroup: "btn-custom",
            button: "bg-custom border-white",
          }}
        /> */}
      </DatatableWrapper>
      {modalShowUserSiteVisit && (
        <UserSiteVisitModal
          show={modalShowUserSiteVisit}
          onHide={() => setModalShowUserSiteVisit(false)}
          visitData={visitData}
          submitSiteVisit={submitSiteVisit}
          refreshList={() => fetchUserTrackings(filterData)}
        />
      )}
      <div className="leads-page">
        {/* Header */}

        {/* DataGrid */}
        <div
          style={{
            height: 400,
            width: "100%",
            marginTop: "20px",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          }}
        >
          <DataGrid
            rows={filteredRows}
            columns={columns}
            pageSize={25}
            rowsPerPageOptions={[25]}
            getRowHeight={() => "auto"}
            disableRowSelectionOnClick
            className="custom-datagrid"
          />
        </div>
      </div>
    </Container>
  );
};

export default UserTracking;
